/**
 * DataSynchronized.contract.ts — Event Contract System™ (SUPABASE FOUNDATION™).
 * A queued or direct cloud persistence write was confirmed by the api-server
 * → Supabase path. Published by the StorageManager.
 */

import type { EventContract } from '../EventContractRegistry';

export const DataSynchronizedContract: EventContract = {
  name: 'DataSynchronized',
  version: 1,
  description: 'A document write was confirmed persisted to the cloud (api-server → Supabase). One event per synchronized document.',
  publishers: ['storage-manager'],
  subscribers: ['developer-center'],
  fields: [
    { name: 'domain', type: 'string', required: true, description: 'Document domain: profile | backpack | vault | operator' },
    { name: 'key', type: 'string', required: true, description: 'Document key within the domain' },
    { name: 'latencyMs', type: 'number', required: false, description: 'Round-trip latency of the confirming request (null if unmeasured)' },
  ],
  allowExtraFields: true,
  timestampPolicy: 'Publish time (Date.now()) at confirmation.',
  stability: 'stable',
  deprecated: false,
  example: { domain: 'backpack', key: 'store', latencyMs: 84 },
};
